<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="icon">
        <img
          :src="axios.platConfig.fileUri + 'mapicon/' + row.icon + '/4/1.gif'"
          style="width: 30px"
        />
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增车辆类型' : '编辑车辆类型'"
      width="400"
      ref="formModel"
    >
      <Select
        v-model="item.icon"
        style="width: 100%"
        @on-select="selectCartype"
        slot="icon"
      >
        <Avatar
          :src="axios.platConfig.fileUri + 'mapicon/' + item.icon + '/4/1.gif'"
          slot="prefix"
          size="small"
        />
        <Option
          :value="x.icon"
          v-for="(x, index) in forms[1].selectItems"
          :key="index"
          :label="x.name"
        >
          <img
            :src="axios.platConfig.fileUri + 'mapicon/' + x.icon + '/4/1.gif'"
            width="26"
            class="tran"
            style="float: left; margin-top: -6px; margin-right: 10px"
          />
          <span>{{ x.name }}</span>
        </Option>
      </Select>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
var categorys = [];
export default {
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        /* {
          title: "所属单位",
          key: "groupName",
          sort: 1,
        }, */
        {
          title: "创建者账号",
          key: "createAccount",
          sort: 200,
        },
        {
          title: "创建时间",
          key: "createTime",
          sort: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
        },
        {
          title: "操作",
          slot: "action",
          sort: 200,
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        name: "",
        icon: "car",
        remark: "",
        category: "其他类",
        type: "0",
        sort:1
      },

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      searchForms: [
        {
          title: "类型分类",
          key: "categorys",
          type: "Select",
          selectItems: categorys,
        },
        /* {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "2,0",
        }, */
      ],
      total: 0,
      categorys: [],
      forms: [
        {
          title: "类型名称",
          key: "name",
          multiple: true,
          type: "Input",
          required: true,
          span: 24,
          sort: 2,
        },

        {
          title: "类型图标",
          key: "icon",
          slot: "icon",
          slotForm: "icon",
          selectType: "obj",
          selectItems: [
            { name: "小汽车/公务车", icon: "car" },
            { name: "货车/卡车", icon: "truck" },
            { name: "普通箭头/其他车辆", icon: "arrow" },
            { name: "面包车", icon: "mianbaoche001" },
            { name: "摆臂车", icon: "baibiche001" },
            { name: "勾臂车", icon: "goubiche001" },
            { name: "铲车/装载车", icon: "chanche001" },
            { name: "机扫车/吸尘车", icon: "jisaoche001" },
            { name: "扫路车/洗扫车", icon: "saoluche001" },
            { name: "洒水车/环卫车", icon: "sashuiche001" },
            { name: "自卸车/运输车", icon: "zixieche001" },
            { name: "人员", icon: "person001" },
          ],
          required: true,
          span: 24,
          sort: 4,
        },
        {
          title: "类型",
          key: "type",
          key2: "type2",
          type: "Select1",
          st: "roleType",
          required: true,
        },
        {
          title: "类型分类",
          key: "category",
          multiple: false,
          type: "Select",
          selectItems: categorys,
          required: true,
          span: 24,
          sort: 3,
        },
        {
          title: "排序",
          key: "sort",
          type: "InputNumber",
          required: true,
          span: 24,
          sort: 4,
        },
      ],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.dm + "/carType/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (const i in data) {
          data[i].type = String(data[i].type);
          data[i].type2 = this.$t("roleType." + data[i].type);
        }
        console.log(data);
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item = a;
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.dm + "/carType/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.dm + "/carType/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.dm + "/carType/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    //carTypeCategory
    getDictionary() {
      this.axios({
        method: "post",
        url: "/dictionary/item",
        data: {
          keyword: "carTypeCategory",
        },
      }).then((res) => {
        var a = JSON.parse(res.data.data.value);
        categorys.splice(0, 100);
        for (const i in a) {
          categorys.push(a[i].name);
        }
      });
    },
    selectCartype(x) {
      this.selectIcon = x.value;
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
    this.getDictionary();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/system/carType.vue